//import FindWordInsidePopup from "@/pages/comp/plan/word/word_inside/popup/find_list";
import WordInsideFindListArea from "@/pages/comp/plan/word/word_inside/common/find_list";

function FindWordInsidePopup(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    listOpt: {},
    ...props
  };

  return (
    <div>
      <WordInsideFindListArea
        closePopup={myProps.closePopup}
        refreshData={myProps.refreshData}
        callbackData={myProps.callbackData}
        listOpt={myProps.listOpt}
      ></WordInsideFindListArea>
    </div>
  );
};
export default FindWordInsidePopup;